import { Link } from 'react-router'

export function NotFoundPage() {
  return (
    <section className="section shell page-section empty-state">
      <p className="eyebrow">404</p>
      <h1>We couldn’t find that page.</h1>
      <p>The address may have changed, or this page may not have been built yet.</p>
      <Link className="button button--primary" to="/">Return home</Link>
    </section>
  )
}

